// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";

interface Agent {
    img: string;
    name: string;
    tel?: string;
    mobile?: string;
    email?: string;
}

interface AgentsSectionProps {
    showAgents: boolean;
    agents: Agent[];
    agentsLoading: boolean;
    agentsError: string | null;
}

const AgentsSection: React.FC<AgentsSectionProps> = ({ showAgents, agents, agentsLoading, agentsError }) => {

    const { t } = useTranslation();



    if (!showAgents) return null;

    return (
        (agentsLoading || agentsError || agents.length > 0) ? (
            <section className="agent-widget mb-4">
                {agentsLoading ? (
                    <div className="text-center">{t('agents.loadingAgents')}...</div>
                ) : agentsError ? (
                    <div className="text-center text-danger">{agentsError}</div>
                ) : (
                    <div className="row no-gutters justify-content-center">
                        {agents.map((agent, index) => (
                            <div key={index} className="agent-card img-wrapper">
                                <img src={agent.img} alt={agent.name} className="img-fluid" />
                                <div className="w-100 text-center">
                                    <p className="mt-2 mb-0">{agent.name}</p>
                                    <div className="mb-3 d-none">
                                        <a href={`mailto:${agent.email}`}>{agent?.email}</a>
                                    </div>
                                    <div className="mb-3 d-none">
                                        <a href={`tel:${agent.tel}`}>{agent.tel}</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        ) : null
    );
};

export default AgentsSection;